module.exports = __webpack_public_path__ + "img/hindi-lang.46ff6567.svg";